import React, { useState } from 'react';
import type { ButtonCopyTextProps } from '@components/atoms/button-copy-text/types';
import { useCopyToClipboard } from '@hooks/use-copy-to-clipboard';
import { useDebounce } from '@hooks/use-debounce';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CopyIcon } from '../../icons';

import { Button, COPY_ICON_CLASS } from './styles';

const Atom: React.FC<ButtonCopyTextProps> = ({
    copyText,
    className,
    icon,
    tooltipProps,
    onClick,
    revealOnHover,
}) => {
    const [, copy] = useCopyToClipboard();
    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipCloseDebounce = useDebounce(handleTooltipClose, 2000);

    const handleTooltipOpen = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        setOpen(true);
        handleTooltipCloseDebounce();
        onClick?.(e);
    };

    return (
        <Tooltip
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener={true}
            disableHoverListener={true}
            disableTouchListener={true}
            {...tooltipProps}
            slotProps={{
                popper: {
                    disablePortal: true,
                },
            }}
        >
            <Button
                className={
                    [className, revealOnHover && COPY_ICON_CLASS].filter(Boolean).join(' ') ||
                    undefined
                }
                onClick={(e) => {
                    copy(copyText);
                    handleTooltipOpen(e);
                }}
            >
                {icon || <CopyIcon />}
            </Button>
        </Tooltip>
    );
};

export const ButtonCopyText = styled(Atom)({});

export { revealCopyIconOnHoverSx } from './styles';
